
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoindore() {



  const cardData =
  {
    keyword: 'Pune to Indore Cab',
    heading: 'AB Ghule Cabs: Pune to Indore Cab',
    headingDescription: 'AB Ghule Cabs offers comfortable, safe, and affordable Pune to Indore cab services. Whether you are traveling for business, a family visit, or a leisure trip, we ensure a smooth journey with well-maintained vehicles and experienced drivers. Our services are designed to provide you with a hassle-free ride, so you can enjoy the scenic route while traveling from Pune to Indore. Pune is approximately 500 km from Indore.',

    top: 'Top Places to Visit in Indore with AB Ghule Cabs',

    topPlaces: [
        {
          title: "Rajwada Palace",
          description: "Rajwada Palace is a historic landmark that stands as a testament to the architectural brilliance of the Holkar dynasty. Known for its grandeur and intricate design, the palace offers a glimpse into Indore's royal past and is a must-visit for history and architecture enthusiasts."
        },
        {
          title: "Lal Baag Palace",
          description: "Lal Baag Palace, built by the Holkar rulers, is an iconic site in Indore. It features stunning architecture, beautiful gardens, and a rich history that reflects the opulence of the royal family. It's a fascinating destination for those interested in Indore's cultural heritage."
        },
        {
          title: "Kanch Mandir",
          description: "Kanch Mandir, or the Glass Temple, is a mesmerizing Jain temple renowned for its intricate glass mosaics. The temple's interior is adorned with exquisite mirror work, making it a masterpiece of craftsmanship and a peaceful place for spiritual reflection."
        },
        {
          title: "Indore Museum",
          description: "The Indore Museum showcases a diverse collection of ancient artifacts, sculptures, and artworks that provide insights into the region's history and culture. It's an excellent destination for history lovers and those intrigued by India's artistic heritage."
        },
        {
          title: "Annapurna Temple",
          description: "Dedicated to Goddess Annapurna, the Annapurna Temple is one of Indore's most visited pilgrimage sites. The temple's serene atmosphere, vibrant architecture, and spiritual significance make it a haven for devotees and tourists alike."
        },
        {
          title: "Sarafa Bazar",
          description: "Sarafa Bazar is a bustling food street that comes alive every evening, offering a variety of delectable street foods. Known for its vibrant energy and flavorsome dishes, it’s a paradise for food lovers and a must-visit destination in Indore."
        },
        {
          title: "Holkar Cricket Stadium",
          description: "Holkar Cricket Stadium is a modern sports arena that has hosted several domestic and international cricket matches. It’s a popular destination for cricket enthusiasts and an integral part of Indore's sporting culture."
        },
        {
          title: "Bijasen Tekri",
          description: "Bijasen Tekri is a hilltop temple dedicated to Goddess Bijasen, offering breathtaking panoramic views of Indore city. This peaceful location attracts pilgrims and nature lovers, making it a perfect spot for relaxation and photography."
        },
        {
          title: "Patalpani Waterfall",
          description: "Patalpani Waterfall, located near Indore, is a scenic natural attraction, especially during the monsoon season. Surrounded by lush greenery, it’s an ideal spot for picnics, nature walks, and photography, providing a tranquil escape from the city's bustle."
        },
        {
          title: "Ralamandal Wildlife Sanctuary",
          description: "Situated on the outskirts of Indore, Ralamandal Wildlife Sanctuary is home to a variety of flora and fauna. It’s a perfect destination for wildlife enthusiasts and those looking to explore nature through treks and guided tours."
        }
      ],      


   services: [
    {
      "name": "Pune to Indore Taxi Services",
      description: "Travel from Pune to Indore with AB Ghule Cabs and experience top-notch taxi services. We offer prompt, safe, and affordable taxi options to suit all types of travel needs, whether for business or leisure. Our professional drivers ensure that you travel in comfort and arrive at your destination on time."
    },
    {
      "name": "Pune to Indore Cab Booking",
      description: "Booking a cab for your Pune to Indore journey is hassle-free with AB Ghule Cabs. Simply use our easy-to-navigate online booking system or call our customer service. We guarantee convenience, comfort, and excellent service for your trip to Indore."
    },
    {
      "name": "Pune to Indore Car Rental",
      description: "Rent a car from Pune to Indore with AB Ghule Cabs. Our car rental service offers a wide range of vehicles including compact cars, SUVs, and luxury options. Enjoy flexibility, comfort, and affordability for your travel needs, with or without a driver."
    },
    {
      "name": "Pune to Indore Rajwada Palace Cabs",
      description: "Explore the historical beauty of Rajwada Palace with AB Ghule Cabs. Our cabs are perfect for tourists looking to visit this iconic palace. Enjoy a smooth and comfortable ride with knowledgeable drivers who can share local insights along the way."
    },
    {
      "name": "Pune to Indore One-Way Taxi",
      description: "If you're planning a one-way trip from Pune to Indore, AB Ghule Cabs offers affordable one-way taxi services. Skip the hassle of round-trip bookings, and pay only for the distance covered. Book your one-way taxi ride today for a convenient and cost-effective travel solution."
    },
    {
      "name": "Pune to Indore Round Trip Cabs",
      description: "AB Ghule Cabs offers round-trip taxi services for your journey from Pune to Indore. Enjoy a seamless travel experience, where we ensure your comfort and safety. Whether it's a short visit or a longer stay, our round-trip service is ideal for those who prefer to travel both ways in comfort."
    },
    {
      "name": "Pune to Indore Luxury Taxi",
      description: "For a more luxurious travel experience, choose our luxury taxis for your Pune to Indore trip. We provide high-end vehicles that ensure you travel in style and comfort. Our luxury taxi services include premium amenities and a smooth ride to make your journey even more enjoyable."
    },
    {
      "name": "Pune to Indore Self-Drive Car Rental",
      description: "If you prefer to drive yourself, AB Ghule Cabs offers self-drive car rentals for your Pune to Indore trip. Choose from a range of well-maintained cars and enjoy the freedom to explore the journey at your own pace, with the flexibility of a self-driven vehicle."
    },
    {
      "name": "Pune to Indore Private Car Hire",
      description: "Experience the comfort and privacy of a dedicated vehicle with AB Ghule Cabs’ private car hire service. Whether you're traveling alone or with a group, our private car service ensures a personalized travel experience with professional drivers and customized itineraries."
    },
    {
      "name": "Pune to Lal Bagh Palace",
      description: "Visit the beautiful Lal Bagh Palace in Indore with AB Ghule Cabs. Known for its stunning architecture and rich history, the Lal Bagh Palace is a must-see destination. Our experienced drivers will take you there safely, offering comfort and reliability throughout your journey."
    },
    {
      "name": "Pune to Indore Cab",
      description: "Book a reliable and comfortable cab from Pune to Indore with AB Ghule Cabs. Our fleet includes a variety of vehicles, catering to different group sizes and preferences. We ensure a smooth and timely ride so you can focus on enjoying your trip."
    },
    {
      "name": "Pune to Indore Cab Booking",
      description: "Booking a cab with AB Ghule Cabs is simple and efficient. Whether you're booking in advance or on short notice, we ensure that your taxi is ready and waiting for you. Our online booking system and customer support make your Pune to Indore journey easy and stress-free."
    },
    {
      "name": "One-Way Cab Pune to Indore",
      description: "For a one-way taxi ride from Pune to Indore, AB Ghule Cabs offers affordable pricing and great service. Enjoy a hassle-free journey with no return trip obligations. Book your one-way taxi and experience comfortable and punctual service all the way to Indore."
    },
    {
      "name": "Pune to Indore Cab Service",
      description: "AB Ghule Cabs offers reliable, affordable, and comfortable cab services from Pune to Indore. Our professional drivers know the best routes and will ensure a safe, enjoyable, and timely ride for you."
    },
    {
      "name": "Pune to Indore Taxi",
      description: "Travel conveniently from Pune to Indore with AB Ghule Cabs’ taxi services. Our taxis are well-maintained, clean, and air-conditioned to ensure maximum comfort throughout your journey. Whether you're traveling alone or with a group, we have a taxi option for you."
    },
    {
      "name": "Pune to Indore Ertiga Cab",
      description: "For families or small groups, the Ertiga is a great option for traveling from Pune to Indore. AB Ghule Cabs offers Ertiga cabs that provide ample space and comfort, ensuring a smooth journey. Book this spacious and affordable vehicle for your next trip."
    },
    {
      "name": "Pune to Indore Innova Crysta",
      description: "For a luxurious travel experience, book an Innova Crysta cab from Pune to Indore with AB Ghule Cabs. This premium vehicle offers spacious interiors, plush seats, and air-conditioning, making it ideal for long-distance travel with families or groups."
    },
    {
      "name": "Pune to Indore Sedan Cab Services",
      description: "AB Ghule Cabs offers sedan cab services for your Pune to Indore journey. Our sedans are perfect for solo travelers, couples, or small families. Enjoy a smooth ride with high-quality service, ensuring you travel in comfort at an affordable price."
    },
    {
      "name": "Pune to Indore Swift Dzire on Rent",
      description: "Need a compact yet comfortable ride? Rent a Swift Dzire from AB Ghule Cabs for your Pune to Indore trip. Ideal for those traveling on a budget but still wanting comfort, the Swift Dzire offers excellent fuel efficiency and a smooth drive."
    },
    {
      "name": "Pune to Indore Cabs Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Pune to Indore cab services. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],


tableData: [
  ["Pune to Indore Taxi Services", "-Pune to Indore Cab Booking"],
  ["Pune to Indore Car Rental", "-Pune to Indore Rajwada Palace Cabs"],
  ["Pune to Indore One-Way Taxi", "-Pune to Indore Round Trip Cabs"],
  ["Pune to Indore Luxury Taxi", "-Pune to Indore Self-Drive Car Rental"],
  ["Pune to Indore Private Car Hire", "-Pune to Lal Bagh Palace"],
  ["Pune to Indore Cab", "-Pune to Indore Cab Booking"],
  ["One Way Cab Pune to Indore", "-Pune to Indore Cab Service"],
  ["Pune to Indore Taxi", "-Pune to Indore Ertiga Cab"],
  ["Pune to Indore Innova Crysta", "-Pune to Indore Sedan Cab Services"],
  ["Pune to Indore Swift Dzire on Rent", "-Pune to Indore Cab"]
],

whychoose: [
  {
    WhyChooseheading: "Reliable and Timely Service",
    WhyChoosedescription: "At AB Ghule Cabs, we ensure a reliable and timely service for your journey from Pune to Indore. Our drivers are punctual, and we prioritize your travel comfort from the start to the end of the journey."
  },
  {
    WhyChooseheading: "Comfortable and Safe Ride",
    WhyChoosedescription: "Our fleet is equipped with clean, well-maintained vehicles to ensure a smooth and safe journey to Indore. Whether you’re traveling solo or with a group, we offer spacious, air-conditioned cabs that provide utmost comfort."
  },
  {
    WhyChooseheading: "Experienced and Professional Drivers",
    WhyChoosedescription: "We offer highly experienced and professional drivers who are familiar with the Pune to Indore route. Our drivers ensure that you have a safe, pleasant, and smooth ride, keeping your journey stress-free."
  },
  {
    WhyChooseheading: "Affordable and Transparent Pricing",
    WhyChoosedescription: "We provide affordable and competitive pricing for your Pune to Indore trip. Our transparent fare structure ensures that there are no hidden charges, offering you the best value for your money."
  },
  {
    WhyChooseheading: "Well-Maintained Fleet",
    WhyChoosedescription: "Our fleet includes a variety of vehicles, from sedans to SUVs, that are regularly serviced and thoroughly inspected. You can rely on us to provide a safe and enjoyable ride to Indore."
  },
  {
    WhyChooseheading: "24/7 Availability",
    WhyChoosedescription: "AB Ghule Cabs is available 24/7 to cater to your travel needs. Whether you need a last-minute ride or a planned journey, our services are always available to take you from Pune to Indore at any time."
  },
  {
    WhyChooseheading: "Easy Booking Process",
    WhyChoosedescription: "Booking a cab for your Pune to Indore journey is easy and convenient. You can book your ride online via our website or app, or contact our customer service team for personalized assistance."
  },
  {
    WhyChooseheading: "Scenic and Relaxing Journey",
    WhyChoosedescription: "The route from Pune to Indore is scenic and peaceful. Sit back, relax, and enjoy the beautiful landscapes while we take care of the driving."
  }
]

  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a cab from Pune to Indore with AB Ghule Cabs?',
      answer: 'You can easily book a cab via our website, mobile app, or by calling our customer service. We offer multiple booking options for your convenience.',
    },
    {
      id: 'FAQ2',
      question: 'What types of vehicles are available for booking from Pune to Indore?',
      answer: 'We offer a wide range of vehicles, including sedans, SUVs, and luxury cars. Choose a vehicle based on your preferences and group size for a comfortable journey.',
    },
    {
      id: 'FAQ3',
      question: 'Are the drivers experienced for the Pune to Indore route?',
      answer: 'Yes, all our drivers are experienced and familiar with the Pune to Indore route. They ensure that you have a safe and enjoyable journey, adhering to traffic rules and road safety protocols.',
    },
    {
      id: 'FAQ4',
      question: 'How do I pay for my ride from Pune to Indore?',
      answer: 'We provide multiple payment options, including cash, credit/debit cards, and online payment via our mobile app, offering flexibility and convenience for you.',
    },
    {
      id: 'FAQ5',
      question: 'How long does it take to travel from Pune to Indore?',
      answer: 'The drive from Pune to Indore typically takes around 6 to 7 hours, depending on traffic and road conditions.',
    },
    {
      id: 'FAQ6',
      question: 'Do you offer round-trip services for Pune to Indore?',
      answer: 'Yes, we offer round-trip services for your journey. You can book a cab for both your onward and return trips to Indore, with customized schedules.',
    },
    {
      id: 'FAQ7',
      question: 'Is there any luggage limit for the Pune to Indore journey?',
      answer: 'Our vehicles have ample space for luggage. If you have special luggage requirements, please inform us in advance during the booking, and we’ll make arrangements accordingly.',
    },
    {
      id: 'FAQ8',
      question: 'Do you provide intercity cab services for Pune to Indore?',
      answer: 'Yes, we offer intercity cab services from Pune to Indore. We ensure your comfort and safety while you travel between these two cities.',
    },
    {
      id: 'FAQ9',
      question: 'Are there any extra charges for waiting or detours on the Pune to Indore route?',
      answer: 'There may be additional charges for waiting time or detours, depending on your trip specifics. However, we maintain a transparent pricing structure, and any extra charges will be communicated to you beforehand.',
    },
    {
      id: 'FAQ10',
      question: 'Why should I choose AB Ghule Cabs for my Pune to Indore trip?',
      answer: 'AB Ghule Cabs stands out for its reliability, experienced drivers, affordable pricing, well-maintained vehicles, and excellent customer service. We prioritize customer satisfaction and aim to provide a comfortable, safe, and timely ride to Indore.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Vinod Sharma',
      feedback: 'I booked AB Ghule Cabs for a business trip from Pune to Indore, and I’m thoroughly impressed. The driver was professional, and the vehicle was spotless. I could focus on my work while the driver took care of the road. Highly recommended for anyone traveling to Indore.',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Aarti Deshmukh',
      feedback: 'AB Ghule Cabs made my journey from Pune to Indore a pleasant experience. The vehicle was comfortable, and the driver was friendly and knowledgeable about the route. I’ll definitely book again for future trips.',
      rating: 5,
    },
  ];
  
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Indore Cabs | Affordable & Comfortable</title>
  <meta name="description" content="Book Pune to Indore cab services with AB Ghule Cabs. Affordable, reliable, and comfortable one-way and round-trip taxi options. Call +91 8624029699." />
  <meta name="keywords" content="Pune to Indore Taxi Services, Pune to Indore Cab Booking, Pune to Indore Car Rental, Pune to Indore Rajwada palace Cabs, Pune to Indore One-Way Taxi, Pune to Indore Round Trip Cabs, Pune to Indore Luxury Taxi, Pune to Indore Self-Drive Car Rental, Pune to Indore Private Car Hire, Pune to Lal Bagh Palace, Pune to Indore Cab, Pune to Indore Cab Booking, One Way Cab Pune to Indore, Pune to Indore Cab Service, Pune to Indore Taxi, Pune to Indore Ertiga Cab, Pune to Indore Innova Crysta, Pune to Indore Sedan Cab Services, Pune to Indore Swift Dzire on Rent" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Indore Cabs | Affordable & Comfortable" />
  <meta property="og:description" content="Book Pune to Indore cab services with AB Ghule Cabs. Affordable, reliable, and comfortable one-way and round-trip taxi options. Call +91 8624029699." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-indore-cabs.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-indore-cabs" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Indore Cabs",
        description: "Book Pune to Indore cab services with AB Ghule Cabs. Affordable, reliable, and comfortable one-way and round-trip taxi options. Call +91 8624029699.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-indore-cabs",
        "logo": "https://abghulecabs.com/images/pune-to-indore-cabs.jpg",
        "image": "https://abghulecabs.com/images/pune-to-indore-cabs.jpg",
        "priceRange": "₹4000 - ₹8000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-indore-cabs",
          "priceCurrency": "INR",
          "price": "4000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "920"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Vikas Sharma"
            },
            "datePublished": "2024-12-15",
            "reviewBody": "Smooth ride, and the driver was extremely polite. Highly recommend this service for anyone traveling from Pune to Indore."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Sangeeta Patel"
            },
            "datePublished": "2024-12-10",
            "reviewBody": "Affordable prices and good quality service. The cab was well-maintained and the trip was comfortable."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune and Indore",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-indore-cabs"
        },
        "keywords": "Pune to Indore Taxi Services, Pune to Indore Cab Booking, Pune to Indore Car Rental, Pune to Indore Rajwada palace Cabs, Pune to Indore One-Way Taxi, Pune to Indore Round Trip Cabs, Pune to Indore Luxury Taxi, Pune to Indore Self-Drive Car Rental, Pune to Indore Private Car Hire, Pune to Lal Bagh Palace, Pune to Indore Cab, Pune to Indore Cab Booking, One Way Cab Pune to Indore, Pune to Indore Cab Service, Pune to Indore Taxi, Pune to Indore Ertiga Cab, Pune to Indore Innova Crysta, Pune to Indore Sedan Cab Services, Pune to Indore Swift Dzire on Rent"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/22.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetoindore;